export default {
    data() {
      return {
        basicText: 'xxxxxxx',
        basicUrlText: 'xxxxx://xxx.xxxxxxx.xxx/',
        basicEmailText: 'xxxxxxx@xxxxxxx.xxx',
        basicContactText: '+xxx xxxxxxx',
        basicDomainText: 'xxxxxxx.xxx',
        basicMailHostText:
        'xxxxxxx.xxxxxxx.xxx',
        basicIpAddressText: 'xxx.xxx.xxx.xxx',
        basicTldText: '.xxx'
      };
    }
  };
  